export default {
  //
  Authorize: {
    data: [
      [
        2,
        "1",
        "Authorize",
        {
          "connectorId": 1,
          "idTag": "EAAF8026",
          "meterStart": 100,
          "timestamp": "2020-09-25T07:16:08.915Z"
        }
      ]
    ]
  },
  //
  BootNotification: {
    data: [
      [
        2,
        "1",
        "BootNotification",
        {
          "chargePointModel": "SLATE 2",
          "chargePointSerialNumber": "0",
          "chargePointVendor": "Cornerstone",
          "firmwareVersion": "V0.44.00XX"
        }
      ]
    ]
  },
  //
  Heartbeat: {
    data: [
      [2,"1","Heartbeat",{}]
    ]
  },
  //
  MeterValues: {
    data: [
      [
        2,
        "1",
        "MeterValues",
        {
          "connectorId": 1,
          "meterValue": [
            {
              "sampledValue": [
                {
                  "unit": "Wh",
                  "measurand": "Energy.Active.Import.Register",
                  "value": "7241"
                },
                {
                  "phase": "L1-N",
                  "unit": "V",
                  "measurand": "Voltage",
                  "value": "217.6"
                },
                {
                  "phase": "L1",
                  "unit": "A",
                  "measurand": "Current.Import",
                  "value": "0"
                },
                {
                  "phase": "L2-N",
                  "unit": "V",
                  "measurand": "Voltage",
                  "value": "-0.12"
                },
                {
                  "phase": "L2",
                  "unit": "A",
                  "measurand": "Current.Import",
                  "value": "0"
                },
                {
                  "phase": "L3-N",
                  "unit": "V",
                  "measurand": "Voltage",
                  "value": "0.03"
                },
                {
                  "phase": "L3",
                  "unit": "A",
                  "measurand": "Current.Import",
                  "value": "0.2"
                }
              ],
              "timestamp": "2020-09-25T07:41:39.099Z"
            }
          ],
          "transactionId": 267
        }
      ]
    ]
  },
  //
  StartTransaction: {
    data: [
      [
        2,
        "1",
        "StartTransaction",
        {
          "selectTime": 15,
          "connectorId": 2,
          "idTag": "EAAF8026",
          "meterStart": 100,
          "timestamp": "2020-09-25T07:16:08.915Z"
        }
      ]
    ]
  },
  //
  StatusNotification: {
    data: [
      [
        2,
        "1",
        "StatusNotification",
        {
          "connectorId": 1,
          "errorCode": "NoError",
          "vendorId": "Cornerstone",
          "vendorErrorCode": "NoError",
          "status": "SuspendedEV",
          "timestamp": "2020-09-25T07:16:09.121Z"
        }
      ]
    ]
  },
  //
  StopTransaction: {
    data: [
      [
        2,
        "1",
        "StopTransaction",
        {
          "reason": "Local",
          "idTag": "EAAF8026",
          "transactionId": 36,
          "meterStop": 7241,
          "timestamp": "2020-09-25T07:54:00.976Z"
        }
      ]
    ]
  },
  //
  ChangeAvailability: {
    data: [
      [
        2,
        "1",
        "ChangeAvailability",
        {
          connectorId: 1,
          type: "Operative"
        }
      ]
    ]
  },
  //
  SetChargingProfile: {
    data: [
      [2,"1","SetChargingProfile",{}]
    ]
  },
  //
  TriggerMessage: {
    data: [
      [
        2,
        "1",
        "TriggerMessage",
        {
          requestedMessage: "BootNotification",
          connectorId: 1
        }
      ]
    ]
  },
  //
  DataTransfer: {
    data: [
      [
        2,
        "1",
        "DataTransfer",
        {
          vendorId: "Autotoll",
          messageId: "ChargingDetails",
          data: {
            start_time: "2020-09-25T07:54:00.976Z",
            session_fee: "6.00",
            minutes_per_session: "15",
            session_count: "1",
            charging_fee: "6.00"
          }
        }
      ]
    ]
  },
  //
};